import { Component, HostListener, OnInit } from "@angular/core";
import { ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { RetirementPlanDocumentsService } from "../service/retirement-plan-documents.service";
import { BatchAcknowledgementPrintRequest } from "client/app/domains/BatchAcknowledgementPrintRequest";
import { BatchAcknowledgementPrintResponseItem } from "client/app/domains/BatchAcknowledgementPrintResponseItem";
import { GemsService } from "client/app/shared";
import { concatMap, map } from "rxjs/operators";

@Component({
  selector: "app-print-distribution-batch",
  templateUrl: "./print-distribution-batch.component.html",
  styleUrls: ["./print-distribution-batch.component.less"],
  standalone: false
})
export class PrintDistributionBatchComponent implements OnInit {
  processedDistributions: BatchAcknowledgementPrintResponseItem[] = [];
  TodaysDate: string;

  constructor(
    private retirementPlanDocumentsService: RetirementPlanDocumentsService,
    private route: ActivatedRoute,
    private router: Router,
    private changeDetector: ChangeDetectorRef,
    private gemsService: GemsService
  ) { }

  ngOnInit() {
    this.gemsService.getUser().pipe(
      map((user) => ({
        RetirementSpdIds: this.route.snapshot.paramMap.get("RetirementSpdIds").split(","),
        PersonId: user.person_id,
      })),
      concatMap((batch: BatchAcknowledgementPrintRequest) => this.retirementPlanDocumentsService.loadPrintBatchAcknowledgement(batch))
    ).subscribe((data) => {
      this.processedDistributions = data;
      this.changeDetector.detectChanges();
      this.printAndNavigate();
    });

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();
    this.TodaysDate = mm + "/" + dd + "/" + yyyy;
  }

  printAndNavigate() {
    window.print();
  }
  
  @HostListener('window:afterprint', ['$event'])
  onAfterPrint(event: Event): void {
    this.router.navigateByUrl('/admin/retirement-plan-documents');
  }
}
